module.exports = __webpack_public_path__ + "img/47.96866b5d.jpg";